import React from 'react';
import styled from 'styled-components';
import Icon from '../IconBase';

function ClinicIcon({ width, height, ...props }: any) {
  const size = width || height || 20;

  return (
    <Icon data-icon={'home-plus'} viewBox='0 0 20 20' width={size}
      height={size} fill='none' {...props}>
      <g clipPath='url(#clip0_224:355)'>
        <path d='M2.93262 8.30169V16.1074C2.93262 17.212 3.82805 18.1074 4.93262 18.1074H15.1069C16.2115 18.1074 17.1069 17.212 17.1069 16.1074V7.79883' stroke='currentColor' strokeWidth='2' />
        <path d='M1 9.73143L9.1348 2.34507C9.6426 1.88498 10.3981 1.88498 10.9059 2.34507L19.04 9.73143' stroke='currentColor' strokeWidth='2'
          strokeLinecap='round' strokeLinejoin='round' />
        <path d='M9.86426 8.26758V14.3978' stroke='currentColor' strokeWidth='2'
          strokeLinejoin='round' />
        <path d='M12.9297 11.333H6.79949' stroke='currentColor' strokeWidth='2'
          strokeLinejoin='round' />
      </g>
    </Icon>
  );
}

export default styled(ClinicIcon)``;